import { Injectable } from "@angular/core";
import { AppAvailability } from "@ionic-native/app-availability";
import {
  InAppBrowser,
  InAppBrowserObject,
  InAppBrowserOptions,
} from "@ionic-native/in-app-browser";
import { ModalController, Platform } from "ionic-angular";
import { AppPreferences } from "../../shared/local/app-preferences.local";
import { SFGOAuthService } from "../sfgoauth.service/sfgoauth.service";

@Injectable()
export class InappbrowserService {
  constructor(
    public appAvailability: AppAvailability,
    public platform: Platform,
    public inAppBrowser: InAppBrowser,
    private appPreferences: AppPreferences,
    private sfgoAuthService: SFGOAuthService,
    private modalController: ModalController,
  ) {}

  openInAppBrowser(
    url: string,
    target: "_blank" | "_system" | "_self" = "_blank",
    options?: InAppBrowserOptions
  ) {
    if (this.platform.is("cordova")) {
      if (!options) {
        options = {
          location: "yes",
        };
      }
      return this.inAppBrowser.create(url, target, options);
    } else {
      const win = window.open(url, target);
      win.focus();
    }
  }

  async encryptExtraData(extraData: any) {
    const SFGoAuth = await this.appPreferences.getAuth();
    const SFGoStorage = await this.sfgoAuthService.getGDStorage();
    const storedPrelogin = SFGoStorage.storedPrelogin;
    const queryParams = JSON.stringify({
      token: SFGoAuth.id,
      storedPrelogin: storedPrelogin,
      data: extraData,
    });

    const encrypt = btoa(queryParams);
    return encrypt;
  }

  async openIframeWithEncryptData(endpoint: string, extraData: any) {
    const encrypt = await this.encryptExtraData(extraData);
    const urlWithExtraData = endpoint + encrypt;
    console.log('urlWithExtraData',urlWithExtraData);
    return urlWithExtraData;
  }

  async openInAppBrowserWithEncryptData(
    endpoint: string,
    extraData: any,
    options?: InAppBrowserOptions,
    useModal?: boolean,
    page?: string
  ) {
    const encrypt = await this.encryptExtraData(extraData);
    const urlWithExtraData = endpoint + encrypt;

    const defaultOptions: InAppBrowserOptions = {
      location: "no",
      hidden: "no",
      clearcache: "yes",
      clearsessioncache: "yes",
      hardwareback: "yes",
      toolbar: "no",
      fullscreen: "no", // npm run postinstall || npm run cpr:iab
    };

    if (this.platform.is("cordova")) {
      const browser: InAppBrowserObject = this.openInAppBrowser(
        urlWithExtraData,
        "_blank",
        options ? options : defaultOptions
      );

      browser.executeScript({
        code: "\
          var message = 'this is the message';\
          var messageObj = {my_message: message};\
          var stringifiedMessageObj = JSON.stringify(messageObj);\
          webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);",
      });
      const result = {
        use: "inappbrowser",
        browser,
      };
      return result;
    } else {
      if (useModal) {
        const modal = this.openInappbrowserAsModal(extraData, page);
        return { use: "modal", modal };
      } else {
        const win = window.open(urlWithExtraData);
        win.focus();
        return { use: "new-tab" };
      }
    }
  }

  openModal(page: string = "MarketplacePage", param: any, cssClss: any) {
    const modal = this.modalController.create(page, param, cssClss);
    return modal;
  }

  openInappbrowserAsModal(extraData: any, page: string) {
    const param = {
      data: extraData,
    };

    return this.openModal(page, param, {
      cssClass: "grd-modal-larger",
    });
  }

  openApplication(
    andriodSchemaName: string,
    iosSchemaName: string,
    appUrl: string,
    httpUrl: string,
    username: string
  ) {
    var app: string;
    if (this.platform.is("android")) {
      app = andriodSchemaName;
    } else if (this.platform.is("ios")) {
      app = iosSchemaName;
    } else {
      // running on browser
      this.inAppBrowser.create(httpUrl + username, "_blank");
      return;
    }

    this.appAvailability.check(app).then(
      () => {
        // running app on device
        this.inAppBrowser.create(appUrl + username, "_system");
      },
      () => {
        // when app is not install on device then run in browser
        this.inAppBrowser.create(httpUrl + username, "_system");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/inappbrowser/inappbrowser.service.ts